import { render, staticRenderFns } from "./DropdownSlider.vue?vue&type=template&id=474982cc&scoped=true"
import script from "./DropdownSlider.vue?vue&type=script&lang=js"
export * from "./DropdownSlider.vue?vue&type=script&lang=js"
import style0 from "./DropdownSlider.vue?vue&type=style&index=0&id=474982cc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474982cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474982cc')) {
      api.createRecord('474982cc', component.options)
    } else {
      api.reload('474982cc', component.options)
    }
    module.hot.accept("./DropdownSlider.vue?vue&type=template&id=474982cc&scoped=true", function () {
      api.rerender('474982cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/DropdownSlider.vue"
export default component.exports